// import { useQuery } from '@tanstack/react-query';
// import { propertyServices } from '../services/property.service';

// export const useProperties = ({
//   page,
//   limit,
//   propertyCategory,
//   propertyType,
//   status,
//   approvalStatus,
//   furnishing,
//   constructionStatus,
//   search,
//   sortBy,
//   sortOrder,
// }) => {
//   return useQuery({
//     queryKey: [
//       'properties',
//       {
//         page,
//         limit,
//         propertyCategory,
//         propertyType,
//         status,
//         approvalStatus,
//         furnishing,
//         constructionStatus,
//         search,
//         sortBy,
//         sortOrder,
//       },
//     ],
//     queryFn: () =>
//       propertyServices.getProperties({
//         page,
//         limit,
//         propertyCategory,
//         propertyType,
//         status,
//         approvalStatus,
//         furnishing,
//         constructionStatus,
//         search,
//         sortBy,
//         sortOrder,
//       }),
//     staleTime: 5 * 60 * 1000,
//     gcTime: 10 * 60 * 1000,
//     keepPreviousData: true,
//   });
// };


import { useQuery } from '@tanstack/react-query';
import { propertyServices } from '../services/property.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get all properties
 */
export const useProperties = ({
  page,
  limit,
  propertyCategory,
  propertyType,
  status,
  approvalStatus,
  furnishing,
  constructionStatus,
  search,
  sortBy,
  sortOrder,
}) => {
  return useQuery({
    queryKey: [
      'properties',
      {
        page,
        limit,
        propertyCategory,
        propertyType,
        status,
        approvalStatus,
        furnishing,
        constructionStatus,
        search,
        sortBy,
        sortOrder,
      },
    ],

    queryFn: async () => {
      try {
        return await propertyServices.getProperties({
          page,
          limit,
          propertyCategory,
          propertyType,
          status,
          approvalStatus,
          furnishing,
          constructionStatus,
          search,
          sortBy,
          sortOrder,
        });
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,
  });
};